export default __webpack_public_path__ + "static/media/Coral.947abe45.jpg";